import { Company, ReceivedCheck } from 'src/types/data';

// Add a received check to a rib
export const addReceivedCheck = (
  companies: Company[],
  companyId: number,
  ribId: number,
  receivedCheck: ReceivedCheck
): Company[] =>
  companies.map((company) =>
    company.id === companyId
      ? {
          ...company,
          ribs: company.ribs.map((rib) =>
            rib.id === ribId
              ? { ...rib, recieved_checks: [...rib.recieved_checks, receivedCheck] }
              : rib
          ),
        }
      : company
  );

  // Update a received check in a rib
  export function updateReceivedCheck(
    companies: Company[],
    companyId: number,
    ribId: number,
    receivedCheck: Partial<ReceivedCheck>
  ): Company[] {
    return companies.map((company) => {
      if (company.id !== companyId) return company;
  
      return {
        ...company,
        ribs: company.ribs.map((rib) => {
          if (rib.id !== ribId) return rib;
  
          return {
            ...rib,
            recieved_checks: rib.recieved_checks.map((check) => {
              if (check.id !== receivedCheck.id) return check;
  
              // Merge partial fields into the existing check object
              return { ...check, ...receivedCheck };
            }),
          };
        }),
      };
    });
  }
  

// Remove a received check from a rib
export const removeReceivedCheck = (
  companies: Company[],
  companyId: number,
  ribId: number,
  checkId: number
): Company[] =>
  companies.map((company) =>
    company.id === companyId
      ? {
          ...company,
          ribs: company.ribs.map((rib) =>
            rib.id === ribId
              ? {
                  ...rib,
                  recieved_checks: rib.recieved_checks.filter((check) => check.id !== checkId),
                }
              : rib
          ),
        }
      : company
  );
